import script from "./Ok.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ok.vue?vue&type=script&setup=true&lang=ts"

import "./Ok.vue?vue&type=style&index=0&id=35e2a160&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e2a160"]])

export default __exports__